import React from 'react';
import useWindowSize from "../../hooks/useWindowSize";

const CallButton: React.FC = () => {
  const handleOnClick = () => {
    window.open(`tel:+447936885460}`, '_self');
  }

  const size = useWindowSize();

  return size.width && size.width >= 1280 ? (
    <div className="relative top-1 2xl:pr-10 translate-x-4">
      <span className="text-white/80 block text-lg 2xl:text-xl font-medium">07936 885460</span>
    </div>
  ) : (
    <button className="mr-12 translate-y-2 sm:translate-y-0 relative top-1 2xl:pr-10 border border-white/40 px-3 sm:px-4 py-2 text-white hover:border-accent hover:text-accent transition-colors rounded" onClick={handleOnClick}>
      <span className="text-sm sm:text-base font-semibold">Call us</span>
    </button>
  );
}

export default CallButton;
